import { render, staticRenderFns } from "./QNotificationMenuMessagesAlert.vue?vue&type=template&id=041eda3d&"
import script from "./QNotificationMenuMessagesAlert.vue?vue&type=script&lang=js&"
export * from "./QNotificationMenuMessagesAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports